<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";

export default {
  name: "firebase",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Dashboard FireBase",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: this.$t("menuitems.dashboards.firebase"),
    }
  },
  created() {
    window.location.href = 'https://console.firebase.google.com/project/pickup-328914/overview';
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
  </Layout>
</template>

<style scoped>

</style>